"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MyDocumentsPage = void 0;
const doshx_controls_web_1 = require("doshx_controls_web");
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const console_1 = require("../../../../reducers/slices/console");
const react_router_dom_1 = require("react-router-dom");
const get_documents_thunk_1 = require("../../../../reducers/slices/document/thunks/get/get_documents_thunk");
const document_list_1 = require("../document/components/document_list");
const constants_1 = require("../../../../constants/constants");
const document_overview_thunk_1 = require("../../../../reducers/slices/document/thunks/document_overview_thunk");
const MyDocumentsPage = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { signature, documents, overview } = (0, react_redux_1.useSelector)((state) => state.documentState);
    const { user, newRegistration, token } = (0, react_redux_1.useSelector)((state) => state.userState);
    const [selectedStatus, setSelectedStatus] = (0, react_1.useState)(null);
    const [timeline, seTimeline] = (0, react_1.useState)("");
    const [currentPage, setCurrentPage] = (0, react_1.useState)(1);
    const [itemsPerPage, setItemsPerPage] = (0, react_1.useState)(10);
    // Fetch documents with pagination params
    const fetchDocuments = (page, size, status) => {
        dispatch((0, get_documents_thunk_1.get_documents_thunk)({
            data: Object.assign({ page: page.toString(), size: size.toString() }, (status && { status })),
        }));
    };
    (0, react_1.useEffect)(() => {
        if (token) {
            // Fetch overview in parallel (doesn't block UI)
            if (overview.length === 0) {
                dispatch((0, document_overview_thunk_1.document_overview_thunk)());
            }
            // Auto-fetch documents on initial load with "SENT" status for better UX in mobile WebView
            // This ensures users see their pending documents immediately
            if (documents.length === 0 && !selectedStatus) {
                setSelectedStatus("SENT");
                fetchDocuments(1, itemsPerPage, "SENT");
            }
        }
    }, [token]);
    (0, react_1.useEffect)(() => {
        dispatch((0, console_1.setPageTitle)("My documents"));
        dispatch((0, console_1.setShowMenu)(true));
    }, []);
    return (react_1.default.createElement("div", { className: `${newRegistration ? "flex" : ""} gap-4 mb-4 px-2 sm:px-0` },
        react_1.default.createElement("div", { className: "flex flex-col gap-4 w-full" },
            react_1.default.createElement("div", { className: "grid grid-cols-2 lg:grid-cols-6 gap-2 sm:gap-3 lg:gap-4 w-full" }, constants_1.MENUS.map((x) => {
                var _a, _b;
                return (react_1.default.createElement("div", { key: x === null || x === void 0 ? void 0 : x.status, onClick: () => {
                        setSelectedStatus(x === null || x === void 0 ? void 0 : x.status);
                        setCurrentPage(1); // Reset to page 1 when status changes
                        fetchDocuments(1, itemsPerPage, x === null || x === void 0 ? void 0 : x.status);
                    }, className: `flex flex-col gap-2 sm:gap-4 border border-1 ${selectedStatus === (x === null || x === void 0 ? void 0 : x.status) ? "border-white bg-white" : `${x.borderColor} ${x.backgroundColor}`} rounded-md p-3 sm:p-3 lg:p-4 min-w-0 cursor-pointer shadow-md hover:shadow-lg transition-shadow` },
                    react_1.default.createElement("div", { className: "" },
                        react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: x.title }),
                        react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: x.subTitle, size: "xsmall" })),
                    react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: `${(_b = (_a = overview.find((z) => z.status === (x === null || x === void 0 ? void 0 : x.status))) === null || _a === void 0 ? void 0 : _a.amount) !== null && _b !== void 0 ? _b : x.amount}`, size: "large" })));
            })),
            react_1.default.createElement("div", { className: "flex justify-end mt-4" },
                react_1.default.createElement("div", { className: "bg-white rounded-md w-40" },
                    react_1.default.createElement(doshx_controls_web_1.DropdownControl, { label: "Timeframe", size: "small", options: constants_1.TIMELINES, value: timeline, borderColor: "border-white", textColor: "text-black", labelColor: "text-black", iconColor: "text-black", onChange: (value) => __awaiter(void 0, void 0, void 0, function* () {
                            seTimeline(value);
                        }) }))),
            react_1.default.createElement(document_list_1.DocumentList, { status: selectedStatus, currentPage: currentPage, itemsPerPage: itemsPerPage, onPageChange: (page) => {
                    setCurrentPage(page);
                    fetchDocuments(page, itemsPerPage, selectedStatus);
                }, onItemsPerPageChange: (size) => {
                    setItemsPerPage(size);
                    setCurrentPage(1); // Reset to page 1 when page size changes
                    fetchDocuments(1, size, selectedStatus);
                } }))));
};
exports.MyDocumentsPage = MyDocumentsPage;
